import { fetchWithAuth, getCSRFToken } from './authApi';
import IUserPoints from '../models/IUserPoints';

export interface ReportedMinBet {
    gameType: string,
    minBet: number,
}

export interface ReportResult {
    gameType: string,
    outcome: 'accepted' | 'shadow_accepted' | 'rejected',
    pointsAwarded: number,
    reasons: string[],
    currentMinBet?: number,
    distanceMeters: number,
}

export interface ReportMinBetsResponse {
    results: ReportResult[],
    total: number,
    monthly: number,
    reportCount: number,
    pointsAwarded: number,
}

export async function reportMinBets(
    casinoId: number,
    payload: { latitude: number, longitude: number, reports: ReportedMinBet[] },
): Promise<ReportMinBetsResponse> {
    const csrf = await getCSRFToken();
    const res = await fetchWithAuth(`/api/v1/casinos/${casinoId}/min-bets`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
        body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Failed to submit report');
    return data;
}

export async function fetchUserPoints(): Promise<IUserPoints | null> {
    const res = await fetchWithAuth('/api/v1/users/me/points', { method: 'GET' });
    if (!res.ok) return null;
    const data = await res.json();
    return {
        total: data.total ?? 0,
        monthly: data.monthly ?? 0,
        reportCount: data.reportCount ?? 0,
    };
}
